import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import {
  createGlobalEventTemplate,
  deleteGlobalEventTemplate,
  getGlobalEventTemplates,
  updateGlobalEventTemplate
} from '~/api/globalEventTemplates';

export const GLOBAL_EVENT_TEMPLATES_QUERY_KEY = 'global-event-templates';

export const useGlobalEventTemplates = () =>
  useQuery(GLOBAL_EVENT_TEMPLATES_QUERY_KEY, getGlobalEventTemplates);

export const useCreateGlobalEventTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(createGlobalEventTemplate, {
    onSuccess: () => {
      toast('Global template created');
      queryClient.invalidateQueries(GLOBAL_EVENT_TEMPLATES_QUERY_KEY);
    },
    onError: (e: any) => {
      toast(
        e?.response?.data?.message ||
          'There was an error creating the template'
      );
    }
  });
};

export const useUpdateGlobalEventTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(updateGlobalEventTemplate, {
    onSuccess: () => {
      toast('Global template updated');
      queryClient.invalidateQueries(GLOBAL_EVENT_TEMPLATES_QUERY_KEY);
    },
    onError: (e: any) => {
      toast(
        e?.response?.data?.message ||
          'There was an error updating the template'
      );
    }
  });
};

export const useDeleteGlobalEventTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteGlobalEventTemplate, {
    onSuccess: () => {
      toast('Global template deleted');
      queryClient.invalidateQueries(GLOBAL_EVENT_TEMPLATES_QUERY_KEY);
    },
    onError: (e: any) => {
      toast(
        e?.response?.data?.message ||
          'There was an error deleting the template'
      );
    }
  });
};
